import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireGuest } from "@/lib/guards";
import { z } from "zod";

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/auth")({
  validateSearch: searchSchema,
  beforeLoad: requireGuest,
  component: Outlet,
});
